import { useAction, useDidMount } from '@agro-club/frontend-shared'
import UserNotificationActions from 'modules/domain/userNotifications/duck'
import UserNotificationSelectors from 'modules/domain/userNotifications/selectors'
import { UserNotification } from 'modules/domain/userNotifications/types'
import { Progress, ResourceHook } from 'modules/types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

export const useUserNotificationList: ResourceHook<UserNotification[], void[]> = () => {
  const progress = useSelector(UserNotificationSelectors.listFetchProgress)
  const list = useSelector(UserNotificationSelectors.userNotificationList)
  const fetchAction = useAction(UserNotificationActions.listRequested, {})

  useDidMount(() => {
    if (progress !== Progress.SUCCESS) {
      fetchAction()
    }
  })

  return [progress, list]
}

export const useUserNotification: ResourceHook<UserNotification, [string]> = (id: string) => {
  const meta = useSelector((state) => UserNotificationSelectors.meta(state, id))
  const notification = useSelector((state) => UserNotificationSelectors.userNotification(state, id))
  const fetchAction = useAction(UserNotificationActions.itemRequested, id)

  useDidMount(() => {
    if (!notification || notification.id !== id) {
      fetchAction()
    }
  })

  return [meta.fetchProgress, notification]
}

export const useUserNotificationById: ResourceHook<UserNotification, [string]> = (id: string) => {
  const meta = useSelector((state) => UserNotificationSelectors.meta(state, id))
  const item = useSelector((state) => UserNotificationSelectors.userNotification(state, id))
  const fetchAction = useAction(UserNotificationActions.itemRequested, id)

  useEffect(() => {
    if (id && (!item || id !== item.id)) {
      fetchAction()
    }
  }, [item, fetchAction, id])

  return [meta.fetchProgress, item]
}
